/* Coziness product-card image slider
   ================================================================
   Global asset — runs on every page, handles every card slider
   regardless of when/how the card got into the DOM.

   ARROW CLICKS are delegated at the DOCUMENT level so they always
   work, even if initSlider never runs for a given slider (race
   conditions, framework weirdness, async injection quirks).

   Per-slider init binds scroll listener, dots updating, and
   swipe-bubble-blocking. */

(function () {
    'use strict';

    /* ═══════════════════════════════════════════════════════════════
       MARKUP AUS DEN DATEN — product-card.liquid liefert pro Karte nur
       noch das erste Bild als Bild-Link. Die weiteren Bilder stehen als
       JSON in data-slides: [[src (width=1200), Breite, Hoehe, Alt?], …]
       (Alt fehlt = gleicher Alt wie das erste Bild).
       Daraus entsteht hier genau das Markup, das vorher serverseitig
       mitkam:
       · Dots — nur wo sie nicht schon im HTML stehen (Karten ab
         Position 9 einer Liste, force_lazy-Karten), sobald die Karte in
         die Naehe des Viewports kommt, nach einem Re-Render (Filter,
         Sortierung) gleich beim Einsetzen (sie sind auch ohne Hover
         sichtbar, Touch-Geraete brauchen sie)
       · Slides + Pfeile — bei der ersten Interaktion (Hover, Touch,
         Fokus) oder spaetestens beim ersten Pfeilklick.
       Die Pfeil-Beschriftungen kommen aus den Locale-Keys
       cz.product_card.prev_image_aria / next_image_aria, die
       layout/theme.liquid als data-Attribute an dieses <script> haengt. */
    var SLIDE_WIDTHS = [200, 400, 600, 800, 1000, 1200];
    var SCRIPT = document.currentScript;
    var LABEL_PREV = (SCRIPT && SCRIPT.getAttribute('data-prev-label')) || '';
    var LABEL_NEXT = (SCRIPT && SCRIPT.getAttribute('data-next-label')) || '';
    var ARROW_SVG = {
        prev: '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" aria-hidden="true"><path d="M8.5 1L1.5 8L8.5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        next: '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" aria-hidden="true"><path d="M1.5 1L8.5 8L1.5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };

    function slideData(slider) {
        if (slider.__czSlides) return slider.__czSlides;
        var list = null;
        try { list = JSON.parse(slider.getAttribute('data-slides') || 'null'); } catch (e) { list = null; }
        slider.__czSlides = Array.isArray(list) ? list : [];
        return slider.__czSlides;
    }

    /* Dots: die ersten 8 Karten einer Liste (ohne force_lazy) bringen sie
       schon im HTML mit (product-card.liquid), dann passiert hier nichts.
       Erster Dot aktiv — vor dem Ausbau gibt es nur ein Slide, der Track
       kann also noch nicht gescrollt sein. */
    function buildDots(slider) {
        if (slider.querySelector('.cz-card-slider__dots')) return;
        var track = slider.querySelector('.cz-card-slider__track');
        var count = slideData(slider).length + 1;
        if (!track || count < 2) return;

        var dots = document.createElement('div');
        dots.className = 'cz-card-slider__dots';
        dots.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < count; i++) {
            var dot = document.createElement('span');
            dot.className = 'cz-card-slider__dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('data-slide', String(i));
            dots.appendChild(dot);
        }
        slider.insertBefore(dots, track.nextSibling);
    }

    function buildArrows(slider) {
        if (slider.querySelector('.cz-card-slider__arrow')) return;
        var arrows = ['prev', 'next'].map(function (dir) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'cz-card-slider__arrow cz-card-slider__arrow--' + dir;
            btn.setAttribute('aria-label', dir === 'prev' ? LABEL_PREV : LABEL_NEXT);
            btn.innerHTML = ARROW_SVG[dir];
            /* Entsteht der Pfeil waehrend der Hover schon laeuft, haette er
               keinen Vorher-Zustand und waere sofort da. Kurz mit Opacity 0
               einhaengen, Style auswerten lassen, Inline-Wert wieder weg —
               dann laeuft die normale 0.2s-Einblendung aus cz-v2.css. */
            btn.style.opacity = '0';
            slider.appendChild(btn);
            return btn;
        });
        void arrows[0].offsetWidth;
        arrows.forEach(function (btn) { btn.style.removeProperty('opacity'); });
    }

    function hydrate(slider) {
        if (slider.__czHydrated) return;

        var list = slideData(slider);
        var track = slider.querySelector('.cz-card-slider__track');
        var firstLink = track && track.querySelector('a.cz-card-slider__slide');
        var firstImg = firstLink && firstLink.querySelector('img');
        if (!list.length || !firstImg) return;
        slider.__czHydrated = true;

        var frag = document.createDocumentFragment();
        list.forEach(function (slide, i) {
            var src = slide[0];
            var width = parseInt(slide[1], 10) || 0;
            var height = parseInt(slide[2], 10) || 0;
            var maxW = width || 1200;
            var srcset = [];
            var url;
            SLIDE_WIDTHS.forEach(function (w) {
                if (w > maxW) return;
                url = new URL(src, location.href);
                url.searchParams.set('width', w);
                srcset.push(url.toString() + ' ' + w + 'w');
            });

            var img = document.createElement('img');
            img.className = firstImg.className;
            img.alt = slide.length > 3 ? (slide[3] || '') : firstImg.alt;
            img.width = width;
            img.height = height;
            img.decoding = 'async';
            /* Das zweite Bild sofort, weil gleich gewischt wird; der Rest lazy. */
            img.loading = i === 0 ? 'eager' : 'lazy';
            img.draggable = false;
            if (srcset.length) {
                img.sizes = firstImg.getAttribute('sizes') || '100vw';
                img.srcset = srcset.join(', ');
            }
            img.src = src;

            var link = document.createElement('a');
            link.href = firstLink.getAttribute('href');
            link.className = 'cz-card-slider__slide';
            link.draggable = false;
            link.setAttribute('data-instant', '');
            link.appendChild(img);
            frag.appendChild(link);
        });
        track.appendChild(frag);

        buildDots(slider);
        buildArrows(slider);
    }

    /* ═══════════════════════════════════════════════════════════════
       BULLETPROOF ARROW CLICKS — document-level delegation
       Caught at capture phase so nothing downstream can swallow them. */
    document.addEventListener('click', function (e) {
        var arrow = e.target.closest && e.target.closest('.cz-card-slider__arrow');
        if (!arrow) return;

        var slider = arrow.closest('.cz-card-slider');
        if (!slider) return;
        var track = slider.querySelector('.cz-card-slider__track');
        if (!track) return;

        e.preventDefault();
        e.stopPropagation();
        hydrate(slider);

        var slideW = track.clientWidth;
        if (!slideW) return;

        /* Read current index from actual scroll position — avoids
           any stale cached index inside the per-slider closure. */
        var currentIdx = Math.round(track.scrollLeft / slideW);
        var slideCount = slider.querySelectorAll('.cz-card-slider__slide').length;
        var dir = arrow.classList.contains('cz-card-slider__arrow--next') ? 1 : -1;
        var targetIdx = Math.max(0, Math.min(currentIdx + dir, slideCount - 1));

        if (typeof track.scrollTo === 'function') {
            track.scrollTo({ left: targetIdx * slideW, behavior: 'smooth' });
        } else {
            track.scrollLeft = targetIdx * slideW;
        }
    }, true /* capture phase — runs before anything can stopPropagation it */);

    /* ═══════════════════════════════════════════════════════════════
       DOTS ERST IN VIEWPORT-NAEHE — 300px Vorlauf, damit sie beim
       Scrollen schon stehen, bevor die Karte sichtbar wird. In einer
       horizontalen Produkt-Schiene (scroll-carousel) gleich fuer alle
       Karten der Schiene: deren seitlich versteckte Karten schneiden den
       Viewport erst beim Wischen, die Dots waeren sonst einen Frame spaet. */
    var NEAR = 300;
    var dotsObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var rail = entry.target.closest('scroll-carousel');
            var sliders = rail ? rail.querySelectorAll('[data-card-slider]') : [entry.target];
            Array.prototype.forEach.call(sliders, function (slider) {
                dotsObserver.unobserve(slider);
                buildDots(slider);
            });
        });
    }, { rootMargin: NEAR + 'px 0px' }) : null;

    /* NACH EINEM RE-RENDER SOFORT — Filter/Sortierung einer Kollektion
       (oder ein nachgeladener Tab) setzt neue Karten ein, Karten ab
       Position 9 ruecken dabei nach oben, oft direkt in den Viewport.
       Ueber den Observer kaemen ihre Dots erst mit dessen Callback, also
       nach dem ersten Paint der neuen Karten. Darum nach eingesetzten
       Karten alle noch wartenden Slider pruefen: wer in denselben
       300px liegt wie beim Observer (Schienen-Karten ueber die Lage der
       Schiene, wie oben), bekommt die Dots gleich. Erst alle Lagen lesen,
       dann bauen — im Wechsel erzwaenge jeder Slider ein neues Layout.
       Nicht beim ersten Laden: da bringen die sichtbaren Karten ihre Dots
       aus dem HTML mit, und das CSS steht evtl. noch nicht. */
    function nearViewport(el) {
        var r = el.getBoundingClientRect();
        if (!r.width && !r.height) return false; /* display:none, z.B. versteckter Tab am Handy */
        var root = document.documentElement;
        return r.bottom >= -NEAR && r.top <= (window.innerHeight || root.clientHeight) + NEAR &&
            r.right >= 0 && r.left <= (window.innerWidth || root.clientWidth);
    }

    function buildNearDots(sliders) {
        var near = [];
        Array.prototype.forEach.call(sliders, function (slider) {
            if (!slider.__czInit || slider.querySelector('.cz-card-slider__dots')) return;
            if (nearViewport(slider.closest('scroll-carousel') || slider)) near.push(slider);
        });
        near.forEach(function (slider) {
            dotsObserver.unobserve(slider);
            buildDots(slider);
        });
    }

    /* ═══════════════════════════════════════════════════════════════
       PER-SLIDER INIT — dots updating + swipe drag isolation */
    function initSlider(slider) {
        if (slider.__czInit) return;

        var track = slider.querySelector('.cz-card-slider__track');
        if (!track || !slideData(slider).length) return;
        slider.__czInit = true;

        if (dotsObserver) dotsObserver.observe(slider);
        else buildDots(slider);

        var onIntent = function () { hydrate(slider); };
        slider.addEventListener('pointerenter', onIntent, { once: true });
        slider.addEventListener('touchstart', onIntent, { once: true, passive: true });
        slider.addEventListener('focusin', onIntent, { once: true });

        var currentIndex = 0;

        function updateDots() {
            var slideW = track.offsetWidth;
            if (!slideW) return;
            var idx = Math.round(track.scrollLeft / slideW);
            if (idx === currentIndex) return;
            currentIndex = idx;
            slider.querySelectorAll('.cz-card-slider__dot').forEach(function (d, i) {
                d.classList.toggle('is-active', i === idx);
            });
        }

        var scrollTimer;
        track.addEventListener('scroll', function () {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(updateDots, 60);
        }, { passive: true });

        /* Block swipe gestures from bubbling to ancestor scroll-carousels
           so dragging an image doesn't move the whole product row.
           Pointer Events cover mouse AND touch auf allen modernen Browsern
           (Chrome 55+, Safari 13+, Firefox 59+) — vorher 9 Listener pro
           Slider (mouse + pointer + touch * 3 phases). Jetzt 3 Listener
           pro Slider. Bei ~30 Cards auf Collection-Page = 270 → 90 Listeners. */
        var stopProp = function (e) { e.stopPropagation(); };
        ['pointerdown', 'pointermove', 'pointerup'].forEach(function (ev) {
            track.addEventListener(ev, stopProp, { capture: true, passive: true });
        });

        /* Drag-click suppression: prevent link navigation when the user
           dragged the image rather than clicked. */
        var startX = 0, startY = 0, isDrag = false;
        track.addEventListener('pointerdown', function (e) {
            startX = e.clientX; startY = e.clientY; isDrag = false;
        });
        track.addEventListener('pointermove', function (e) {
            if (Math.abs(e.clientX - startX) > 5 || Math.abs(e.clientY - startY) > 5) isDrag = true;
        });
        track.addEventListener('click', function (e) {
            if (isDrag) { e.preventDefault(); e.stopPropagation(); }
        }, true);
    }

    /* nearNow: nach eingesetzten Karten die Dots der Slider in
       Viewport-Naehe sofort bauen (siehe buildNearDots). */
    function initAll(nearNow) {
        var sliders = document.querySelectorAll('[data-card-slider]');
        sliders.forEach(initSlider);
        if (nearNow === true && dotsObserver) buildNearDots(sliders);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initAll(false); });
    } else {
        initAll(false);
    }

    function hasCards(node) {
        return node.nodeType === 1 &&
            (node.hasAttribute('data-card-slider') || !!node.querySelector('[data-card-slider]'));
    }

    /* Neue Karten (Section-Fetches, Filter, nachgeladene Tabs) — aber
       nicht das, was die Slider selbst einhaengen (Slides, Dots, Pfeile).
       Die Lage-Pruefung nur, wenn wirklich Karten eingesetzt (oder
       umgehaengt, z.B. Ausverkauft-nach-hinten in main-collection) wurden —
       nicht bei jeder anderen DOM-Aenderung der Seite. */
    new MutationObserver(function (mutations) {
        var run = false;
        var cards = false;
        for (var i = 0; i < mutations.length && !cards; i++) {
            var m = mutations[i];
            if (!m.addedNodes.length) continue;
            if (m.target.closest && m.target.closest('.cz-card-slider')) continue;
            run = true;
            for (var j = 0; j < m.addedNodes.length && !cards; j++) {
                cards = hasCards(m.addedNodes[j]);
            }
        }
        if (run) initAll(cards);
    }).observe(document.body, { childList: true, subtree: true });
})();
